import PreferredLanguageField from './PreferredLanguageField'

export default PreferredLanguageField
